import { Flex } from "Element/Flex";
import React from "react";
import { StyledHeroText } from "../styled";
import { faqContent } from "./faqContent";
import { StyledFaqContainer, StyledImg, ContentWrapper } from "./styled";

const Faq = () => {
  return (
    <StyledFaqContainer>
      <Flex
        height="100%"
        width="100%"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <StyledHeroText className="hero-text">
          most popular question
        </StyledHeroText>
        <Flex justifyContent="center" flexDirection="column">
          {faqContent.map((content) => (
            <ContentWrapper
              justifyContent="center"
              flexWrap="nowrap"
              flexDirection="row"
              m="auto"
              key={content.title}
            >
              <StyledImg src={content.img} />
              <Flex className="content">
                <h1>{content.title}</h1>
                <p>{content.desc}</p>
              </Flex>
            </ContentWrapper>
          ))}
        </Flex>
      </Flex>
    </StyledFaqContainer>
  );
};

export default Faq;
